import axios from 'axios'
// import { setInterceptors } from './common/interceptors'
import { store } from '../store/store'
import router from '../router/index'
import { getCookie, removeCookie } from '../utils/cookieNew'
const domain = process.env.VUE_APP_API_URL

/* function createInstance () {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
  })
  return setInterceptors(instance)
}
const instance = createInstance() */
// 모듈화
const request = {
  get (path, header) {
    const currentUrl = document.location.href
    console.log('get Api를 실행하는 곳', currentUrl)
    console.log('get path', path)
    if (sessionStorage.getItem('pathToLoadUnAuth') !== '/' && !path.includes('/scar/image/list') && path !== '/scar/info/list') {
      store.commit('loading', true)
      console.log('API PATH', path)
    } else {
      console.log('!API PATH', path)
    }
    // axios.interceptors.response.use((response) => {store.commit('loading'
    //   store.commit('loading', false)
    //   return response
    // })
    return axios.get(`${domain + path}`, header)
      .catch(error => {
        store.commit('loading', false)
        if (error.response) {
          console.log('error', error)
          if (error.response.status === 500) {
            router.push('/error')
          }
          if (error.response.statusText === 'Unauthorized') {
            console.log('현재위치 겟', document.location.href)
            console.log('권한 오류의 sessionToken', getCookie('token'))
            console.log('권한이 없습니다. (401에러): ' + location.pathname + ' location 패스' + sessionStorage.getItem('pathToLoadUnAuth') + ' router 패스')
            removeCookie('userName')
            store.commit('SET_USERNAME', '')
            removeCookie('token')
            store.commit('SET_TOKEN', '')
            removeCookie('userId')
            store.commit('SET_ID', '')
            /* 하이퍼 존재시 */
            if (location.pathname !== '/login' && location.pathname !== '/') {
              sessionStorage.removeItem('pathToLoadAuthPre')
              sessionStorage.setItem('pathToLoadAuthPre', location.pathname)
              console.log('로그인하고 이동될 경로', location.pathname)
            }
            console.log('하이퍼 -api-', sessionStorage.getItem('pathToLoadAuthPre'))
            console.log('권필경로 -api-', sessionStorage.getItem('pathToLoadAuth'))
            console.log('권없경로 -api-', sessionStorage.getItem('pathToLoadUnAuth'))
            if (sessionStorage.getItem('authErrorCause') !== 'mutated') {
              sessionStorage.setItem('authErrorCause', 'true')
            }
          }
          return Promise.reject(error.response)
        } else if (error.request) {
          // 요청은 성공적으로 생성되었으나 서버로부터 아무 응답이 없는 경우
          console.log('err request', error.request)
        } else {
          // 어떤 이유인지는 모르겠지만 에러가 발생한 경우
          console.log('Error', error.message)
        }
      }).finally(() => {
        if (sessionStorage.getItem('pathToLoadUnAuth') !== '/' && !path.includes('/scar/image/list') && path !== '/scar/info/list') {
          store.commit('loading', false)
        }
      })
  },
  patch (path, data, header) {
    // axios.interceptors.request.use((config) => {
    //   return config
    // })
    const currentUrl = document.location.href
    console.log('patch Api를 실행하는 곳', currentUrl)
    if (sessionStorage.getItem('pathToLoadUnAuth') !== '/') {
      store.commit('loading', true)
    }
    console.log('API PATH', path)
    return axios.patch(`${domain + path}`, data, header)
      .catch(error => {
        store.commit('loading', false)
        if (error.response) {
          console.log('error', error)
          if (error.response.status === 500) {
            router.push('/error')
          }
          if (error.response.statusText === 'Unauthorized') {
            console.log('현재위치 겟', document.location.href)
            console.log('권한 오류의 sessionToken', getCookie('token'))
            console.log('권한이 없습니다. (401에러): ' + location.pathname + ' location 패스' + sessionStorage.getItem('pathToLoadUnAuth') + ' router 패스')
            removeCookie('userName')
            store.commit('SET_USERNAME', '')
            removeCookie('token')
            store.commit('SET_TOKEN', '')
            removeCookie('userId')
            store.commit('SET_ID', '')
            /* 하이퍼 존재시 */
            if (location.pathname !== '/login' && location.pathname !== '/') {
              sessionStorage.removeItem('pathToLoadAuthPre')
              sessionStorage.setItem('pathToLoadAuthPre', location.pathname)
              console.log('로그인하고 이동될 경로', location.pathname)
            }
            console.log('하이퍼 -api-', sessionStorage.getItem('pathToLoadAuthPre'))
            console.log('권필경로 -api-', sessionStorage.getItem('pathToLoadAuth'))
            console.log('권없경로 -api-', sessionStorage.getItem('pathToLoadUnAuth'))
            if (sessionStorage.getItem('authErrorCause') !== 'mutated') {
              sessionStorage.setItem('authErrorCause', 'true')
            }
          }
          return Promise.reject(error.response)
        } else if (error.request) {
          // 요청은 성공적으로 생성되었으나 서버로부터 아무 응답이 없는 경우
          console.log('err request', error.request)
        } else {
          // 어떤 이유인지느 모르겠지만 에러가 발생한 경우
          console.log('Error', error.message)
        }
      }).finally(() => {
        if (sessionStorage.getItem('pathToLoadUnAuth') !== '/') {
          store.commit('loading', false)
        }
      })
  },
  post (path, data, header) {
    const currentUrl = document.location.href
    console.log('post Api를 실행하는 곳', currentUrl)
    if (sessionStorage.getItem('pathToLoadUnAuth') !== '/' && path !== '/reservation/date' && path !== '/scar/image' && path !== '/chatbot') {
      store.commit('loading', true)
    }
    console.log('API PATH', path)
    return axios.post(`${domain + path}`, data, header)
      .catch(error => {
        if (!document.location.href.includes('/scar/scarDetail/')) {
          store.commit('loading', false)
        }
        if (error.response) {
          console.log('errorPost', error)
          console.log('해당도', path, data, header)
          if (error.response.status === 500) {
            router.push('/error')
          }
          if (error.response.statusText === 'Unauthorized') {
            console.log('현재위치 겟', document.location.href)
            console.log('권한 오류의 sessionToken', getCookie('token'))
            console.log('권한이 없습니다. (401에러): ' + location.pathname + ' location 패스' + sessionStorage.getItem('pathToLoadUnAuth') + ' router 패스')
            removeCookie('userName')
            store.commit('SET_USERNAME', '')
            removeCookie('token')
            store.commit('SET_TOKEN', '')
            removeCookie('userId')
            store.commit('SET_ID', '')
            /* 하이퍼 존재시 */
            if (location.pathname !== '/login' && location.pathname !== '/') {
              sessionStorage.removeItem('pathToLoadAuthPre')
              sessionStorage.setItem('pathToLoadAuthPre', location.pathname)
              console.log('로그인하고 이동될 경로', location.pathname)
            }
            console.log('하이퍼 -api-', sessionStorage.getItem('pathToLoadAuthPre'))
            console.log('권필경로 -api-', sessionStorage.getItem('pathToLoadAuth'))
            console.log('권없경로 -api-', sessionStorage.getItem('pathToLoadUnAuth'))
            if (sessionStorage.getItem('authErrorCause') !== 'mutated') {
              sessionStorage.setItem('authErrorCause', 'true')
            }
          }
          return Promise.reject(error.response)
        } else if (error.request) {
          // 요청은 성공적으로 생성되었으나 서버로부터 아무 응답이 없는 경우
          console.log('err request', error.request)
        } else {
          // 어떤 이유인지느 모르겠지만 에러가 발생한 경우
          console.log('Error', error.message)
        }
      }).finally(() => {
        if (sessionStorage.getItem('pathToLoadUnAuth') !== '/' && path !== '/reservation/date' && path !== '/scar/image' && path !== '/chatbot') {
          store.commit('loading', false)
        }
      })
  },
  delete (path, header) {
    const currentUrl = document.location.href
    console.log('delete Api를 실행하는 곳', currentUrl)
    if (sessionStorage.getItem('pathToLoadUnAuth') !== '/' && path !== '/scar/image/delete') {
      store.commit('loading', true)
    }
    console.log('API PATH', path)
    return axios.delete(`${domain + path}`, header)
      .catch(error => {
        store.commit('loading', false)
        if (error.response) {
          console.log('error', error)
          if (error.response.status === 500) {
            router.push('/error')
          }
          if (error.response.statusText === 'Unauthorized') {
            console.log('현재위치 겟', document.location.href)
            console.log('권한 오류의 sessionToken', getCookie('token'))
            console.log('권한이 없습니다. (401에러): ' + location.pathname + ' location 패스' + sessionStorage.getItem('pathToLoadUnAuth') + ' router 패스')
            removeCookie('userName')
            store.commit('SET_USERNAME', '')
            removeCookie('token')
            store.commit('SET_TOKEN', '')
            removeCookie('userId')
            store.commit('SET_ID', '')
            /* 하이퍼 존재시 */
            if (location.pathname !== '/login' && location.pathname !== '/') {
              sessionStorage.removeItem('pathToLoadAuthPre')
              sessionStorage.setItem('pathToLoadAuthPre', location.pathname)
              console.log('로그인하고 이동될 경로', location.pathname)
            }
            console.log('하이퍼 -api-', sessionStorage.getItem('pathToLoadAuthPre'))
            console.log('권필경로 -api-', sessionStorage.getItem('pathToLoadAuth'))
            console.log('권없경로 -api-', sessionStorage.getItem('pathToLoadUnAuth'))
            if (sessionStorage.getItem('authErrorCause') !== 'mutated') {
              sessionStorage.setItem('authErrorCause', 'true')
            }
          }
          return Promise.reject(error.response)
        } else if (error.request) {
          // 요청은 성공적으로 생성되었으나 서버로부터 아무 응답이 없는 경우
          console.log('err request', error.request)
        } else {
          // 어떤 이유인지느 모르겠지만 에러가 발생한 경우
          console.log('Error', error.message)
        }
      }).finally(() => {
        if (sessionStorage.getItem('pathToLoadUnAuth') !== '/' && path !== '/scar/image/delete') {
          store.commit('loading', false)
        }
      })
  },
  put (path, data, header) {
    const currentUrl = document.location.href
    console.log('put Api를 실행하는 곳', currentUrl)
    if (sessionStorage.getItem('pathToLoadUnAuth') !== '/') {
      store.commit('loading', true)
    }
    console.log('API PATH', path)
    return axios.put(`${domain + path}`, data, header)
      .catch(error => {
        store.commit('loading', false)
        if (error.response) {
          console.log('error', error)
          if (error.response.status === 500) {
            router.push('/error')
          }
          if (error.response.statusText === 'Unauthorized') {
            console.log('현재위치 겟', document.location.href)
            console.log('권한 오류의 sessionToken', getCookie('token'))
            console.log('권한이 없습니다. (401에러): ' + location.pathname + ' location 패스' + sessionStorage.getItem('pathToLoadUnAuth') + ' router 패스')
            removeCookie('userName')
            store.commit('SET_USERNAME', '')
            removeCookie('token')
            store.commit('SET_TOKEN', '')
            removeCookie('userId')
            store.commit('SET_ID', '')
            /* 하이퍼 존재시 */
            if (location.pathname !== '/login' && location.pathname !== '/') {
              sessionStorage.removeItem('pathToLoadAuthPre')
              sessionStorage.setItem('pathToLoadAuthPre', location.pathname)
              console.log('로그인하고 이동될 경로', location.pathname)
            }
            console.log('하이퍼 -api-', sessionStorage.getItem('pathToLoadAuthPre'))
            console.log('권필경로 -api-', sessionStorage.getItem('pathToLoadAuth'))
            console.log('권없경로 -api-', sessionStorage.getItem('pathToLoadUnAuth'))
            if (sessionStorage.getItem('authErrorCause') !== 'mutated') {
              sessionStorage.setItem('authErrorCause', 'true')
            }
          }
          return Promise.reject(error.response)
        } else if (error.request) {
          // 요청은 성공적으로 생성되었으나 서버로부터 아무 응답이 없는 경우
          console.log('err request', error.request)
        } else {
          // 어떤 이유인지느 모르겠지만 에러가 발생한 경우
          console.log('Error', error.message)
        }
      }).finally(() => {
        if (sessionStorage.getItem('pathToLoadUnAuth') !== '/') {
          store.commit('loading', false)
        }
      })
  }
}

export const version = {
  versionCheck (payload) {
    return request.get(`/version/check?os=${payload.os}&version=${payload.version}`)
      .then(({ data }) => data)
  }
}

export const main = {
  banner () {
    return request.get('/banner')
      .then(({ data }) => data)
  },
  bannerDetail () {
    return request.get('/banner/detail')
      .then(({ data }) => data)
  }
}

export const user = {
  idFind (userData) {
    return request.post('/account/find/id', userData)
      .then(({ data }) => data)
  },
  loginUser (userData) {
    return request.post('/account/login', userData)
      .then(({ data }) => data)
  },
  logoutUser () {
    return request.post('/account/logout', null, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  checkPw (userData) {
    return request.post('/account/check/password', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  pwFindApproval (userData) {
    return request.post('/account/find/password/temporary', userData)
      .then(({ data }) => data)
  },
  pwFindCertify (userData) {
    return request.post('/account/find/password', userData)
      .then(({ data }) => data)
  },
  changePw (userData) {
    return request.post('/account/change/password', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  joinUser (userData) {
    return request.post('/account/join', userData)
      .then(({ data }) => data)
  },
  checkId (userData) {
    return request.get('/account/check/id?id=' + userData.id)
      .then(({ data }) => data)
  },
  userInfo () {
    return request.get('/account/info', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  userInfoChange (userData) {
    return request.post('/account/update', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  secession () {
    return request.get('/account/withdraw', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  autoLogin (userData) {
    return request.post('/account/login/auto', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  identity () {
    return request.get('/account/identity')
      .then(({ data }) => data)
  },
  identitySuccessPost (payload) {
    return request.post('/account/identity/success', payload)
      .then(({ data }) => data)
  },
  isTemp (payload) {
    return request.post('/account/istemp', payload)
      .then(({ data }) => data)
  },
  isDup (payload) {
    return request.post('/account/isdup', payload)
      .then(({ data }) => data)
  }
}
/* 의료진 API */

export const doctor = {
  doctorList () {
    return request.get('/doctor/list')
      .then(({ data }) => data)
  },
  doctorSchedule () {
    return request.get('/doctor/schedule')
      .then(({ data }) => data)
  }
}

/* 예약 API */

export const reservation = {
  check () {
    return request.get('/reservation/check', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  coming (category) {
    return request.get(`/reservation/coming?category=${category}`)
      .then(({ data }) => data)
  },
  visit () {
    return request.get('/reservation/visit')
      .then(({ data }) => data)
  },
  telReservation (telData) {
    return request.post('/reservation/guest', telData)
      .then(({ data }) => data)
  },
  selectDoctor (reasonData) {
    return request.post('/reservation/doctor', reasonData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  fetchCalendar (requestData) {
    return request.post('/reservation/date', requestData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  reservationList (requestData) {
    return request.post('/reservation/list', requestData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  booking (payload) {
    return request.post('/reservation/booking', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  reBooking (payload) {
    return request.post('/reservation/rebooking', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  updateReservation (requestData) {
    return request.patch('/reservation/update', requestData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  deleteReservation (requestData) {
    return request.delete('/reservation/delete', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      },
      data: requestData
    })
      .then(({ data }) => data)
  },
  getMedicalDate (requestData) {
    return request.post('/reservation/month', requestData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      },
      data: requestData
    })
      .then(({ data }) => data)
  }
}
export const push = {
  read (requestData) {
    return request.patch('/push/read', requestData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  pushList () {
    return request.get('/push/list', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  pushReceived (payload) {
    return request.post('/account/pushcheck', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  pushCheck () {
    return request.get('/account/pushcheck', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  }
}

/* 제증명 API */
export const certificate = {
  certificateList () {
    return request.get('/certificate/list', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  certificateRequest (payload) {
    return request.post('/certificate/request', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  certificateLookup (payload) {
    return request.post('/certificate/history/list', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  certificateLookupDetail (payload) {
    return request.get(`/certificate/history/detail?certificateIssuanceId=${payload}`, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  }
}

/* 수술 */
export const surgery = {
  surgeryList (payload) {
    return request.post('/surgery/list', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  surgeryApply (payload) {
    return request.post('/surgery/apply', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  kakaoUrl () {
    return request.get('/surgery/kakao', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  surgeryReviewList () {
    return request.get('/surgery/review/list', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  surgeryReview (payload) {
    return request.get(`/surgery/review?code=${payload}`, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  }
}

/* 보드 */
export const board = {
  noticeList (payload) {
    return request.get(`/notice/list?max_page=${payload}`)
      .then(({ data }) => data)
  },
  noticeDetail (code) {
    return request.get(`/notice?code=${code}`)
      .then(({ data }) => data)
  },
  noticeListMain () {
    return request.get('/notice/list?max_page=3')
      .then(({ data }) => data)
  }
}
/* 검사결과 */
export const checkup = {
  checkupList (payload) {
    return request.post('/checkup/list', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  checkupDetail (payload) {
    return request.post('/checkup/detail', payload, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  }
}
/* 흉터 */
export const scar = {
  scarInfoList () {
    return request.get('/scar/info/list', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  scarApply (userData) {
    return request.post('/scar/info/apply', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  scarUploadList (userData) {
    return request.get('/scar/image/list?scarInfoCode=' + userData.scarInfoCode, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      }
    })
      .then(({ data }) => data)
  },
  scarUpload (userData) {
    return request.post('/scar/image/upload', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token'),
        'Content-Type': 'multipart/form-data'
      },
      contentType: 'multipart/form-data'
    })
      .then(({ data }) => data)
  },
  scarImageFetch (userData) {
    return request.post('/scar/image', userData, {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      },
      responseType: 'blob'
    })
      .then(({ data }) => data)
  },
  scarImageDelete (userData) {
    return request.delete('/scar/image/delete', {
      headers: {
        Authorization: 'Token ' + getCookie('token')
      },
      data: userData
    })
      .then(({ data }) => data)
  }
}

/* 챗봇 */
export const chat = {
  chatbot (payload) {
    return request.post('/chatbot', payload)
      .then(({ data }) => data)
  }
}
// 회원가입 API

// 비밀번호 변경 API
function changePw (userData) {
  return request.post('/account/change/password', userData, {
    headers: {
      Authorization: 'Token ' + getCookie('token')
    }
  })
}

// 회원정보 변경 API
function changeMemberInfo (userData) {
  return request.post('/account/update', userData, {
    headers: {
      Authorization: 'Token ' + getCookie('token')
    }
  })
}

/* function refreshToken (userData) {
  return instance.get('account/login/auto', userData)
} */

// 로그인 API
function loginUser (userData) {
  return request.post('/account/login', userData, {
    headers: {
      Authorization: 'Token ' + getCookie('token')
    }
  })
}

/* 아이디 찾기 */
function idFindUser (userData) {
  return request.post('/account/find/id', userData)
}

/* 비밀번호 일치여부 */
function checkPw (userData) {
  return request.get('/account/check/password?password=' + userData.password)
}

/* 비밀번호 찾기- 인증회원 */
function passwordFindUser (userData) {
  return request.post('/account/find/password', userData)
}

/* 비밀번호 찾기- 승인회원 */
function passwordFindApproval (userData) {
  return request.post('/account/find/password/temporary', userData)
}

export {
  loginUser,
  idFindUser,
  checkPw,
  passwordFindUser,
  passwordFindApproval,
  changePw,
  changeMemberInfo
}
